import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./loginStyle.css";
import "aos/dist/aos.css";
import { ToastContainer, toast } from "react-toastify";
import Cookies from "js-cookie";

export default function Login() {
    const navigate = useNavigate();

    const [benutzername, setBenutzername] = useState("");
    const [password, setPassword] = useState("");
    const [passwordRepeat, setPasswordRepeat] = useState("");
    const [email, setEmail] = useState("");

    const [checkedNewsletter, setCheckedNewsletter] = useState(false);
    const [checkedAgbs, setCheckedAgbs] = useState(false);

    const [registerState, setRegisterState] = useState(false);

    const [passwordFieldTyp, setPasswordFieldTyp] = useState("password");

    const [cookiesAccepted, setCookiesAccepted] = useState(false);

    const passwordRef = useRef(null);

    useEffect(() => {
        document.title = "DJ - EMAN"

        setCookiesAccepted(localStorage.getItem("cookieConsent") === "accepted");

        if (Cookies.get("token") !== undefined) {
            toast.info("Du bist bereits eingeloggt und wirst weitergeleitet");
            setTimeout(() => {
                navigate("/musicrequesthome");
            }, 1000);
        }
    }, []);

    const handleUsernameKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            passwordRef.current?.focus();
        }
    }

    const handleLoginSubmit = async (e) => {
        e.preventDefault();

        if (!cookiesAccepted) {
            toast.error("Du musst unseren Cookies zustimmen um diese Funktion zu nutzen");
            return;
        }

        const loginData = {
            username: benutzername,
            password: password,
        }

        try {
            const response = await fetch("https://djeman.de:8443/api/v1/login", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(loginData),
            });

            if (response.status == 200) {
                const data = await response.json();
                navigate("/musicrequesthome");
                Cookies.set("token", data.token);
                localStorage.setItem("id", data.id);
                localStorage.setItem("username", data.username);
                localStorage.setItem("role", data.role);
                localStorage.setItem("newsletter", data.newsletter);
                window.location.reload();
            } else if (response.status == 406) {
                toast.error("Dein Account wurde vorrübergehend gesperrt");
            } else {
                toast.error("Benutzername oder Passwort ist falsch");
            }
        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }

        setBenutzername("");
        setPassword("");
    }

    const handleRegisterSubmit = async (e) => {
        e.preventDefault();

        if (!cookiesAccepted) {
            toast.error("Du musst unseren Cookies zustimmen um diese Funktion zu nutzen");
            return;
        }

        if (!checkedAgbs) {
            toast.error("Du musst den Nutzungsbedingungen zustimmen");
            return;
        }

        const registerData = {
            username: benutzername,
            password: password,
            passwordRepeat: passwordRepeat,
            email: email,
            newsletter: checkedNewsletter,
        }

        try {
            const response = await fetch("https://djeman.de:8443/api/v1/register", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(registerData),
            });

            if (response.status == 200) {
                setRegisterState(false);
                toast.success("Du hast dich erfolgreich registriert");
                setBenutzername("");
                setPassword("");
                setPasswordRepeat("");
                setEmail("");
            } else if (response.status == 409) {
                toast.error(await response.text());
                setPassword("");
                setPasswordRepeat("");
            } else {
                toast.error("Fehlerhafte Register Daten");
                setPassword("");
                setPasswordRepeat("");
            }
        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }
    }

    function changeRegisterState(state) {
        setRegisterState(state);
    }

    const requestPasswordReset = async (email) => {
        navigate("/password-reset");
    }

    function changePasswordState() {
        if (passwordFieldTyp === "password") {
            setPasswordFieldTyp("text");
        } else {
            setPasswordFieldTyp("password");
        }
    }

    return (
        <div className="loginContainer">
            <ToastContainer
                theme="dark"
            />
            <h1>Musikwünsche</h1>
            <h2>Sei ein Teil der Playlist und wünsch dir deine Lieblings Songs</h2>
            <div className="loginDataContainer">
                <h3>{registerState ? "Registrieren" : "Login"}</h3>
                    {registerState ? (
                        <>
                            <form onSubmit={handleRegisterSubmit}>
                                <input
                                    type="text"
                                    placeholder="Benutzername"
                                    value={benutzername}
                                    onChange={(e) => setBenutzername(e.target.value)}
                                />
                                <input
                                    type="email"
                                    placeholder="E-Mail"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                <div className="passwordContainer">
                                    <input
                                        type={passwordFieldTyp}
                                        placeholder="Passwort"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                    <img onClick={() => changePasswordState()} src={passwordFieldTyp === "password" ? "/img/eye.svg" : "/img/eye-slash.svg"} />
                                </div>
                                <div className="passwordContainer">
                                    <input
                                        type={passwordFieldTyp}
                                        placeholder="Passwort wiederholen"
                                        value={passwordRepeat}
                                        onChange={(e) => setPasswordRepeat(e.target.value)}
                                    />
                                </div>
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={checkedNewsletter}
                                        onChange={(e) => setCheckedNewsletter(e.target.checked)}
                                    />
                                    Ja, ich möchte über Neugikeiten informiert bleiben und stimme dem Erhalt von E-Mail-Werbung zu. Die Abmeldung ist jederzeit möglich.
                                </label>
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={checkedAgbs}
                                        onChange={(e) => setCheckedAgbs(e.target.checked)}
                                    />
                                    Ja, ich stimme den unten beschriebenen Nutzungsbedingungen zu und bestätige das meine Daten intern verarbeitet werden dürfen.
                                </label>
                                <button type="submit">Registrieren</button>
                                <p onClick={() => changeRegisterState(false)}>Mit bestehendem Account einloggen</p>
                            </form>
                        </>
                    ) : (
                        <>
                            <form autocomplete="on" onSubmit={handleLoginSubmit}>
                                <input
                                    type="text"
                                    placeholder="Benutzername"
                                    autocomplete="username"
                                    value={benutzername}
                                    onChange={(e) => setBenutzername(e.target.value)}
                                    onKeyDown={handleUsernameKeyDown}
                                />
                                <div className="passwordContainer">
                                    <input
                                        type={passwordFieldTyp}
                                        placeholder="Passwort"
                                        autocomplete="current-password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        ref={passwordRef}
                                    />
                                    <img onClick={() => changePasswordState()} src={passwordFieldTyp === "password" ? "/img/eye.svg" : "/img/eye-slash.svg"} />
                                </div>
                                <button type="submit">Login</button>
                                <p onClick={() => requestPasswordReset()}>Passwort vergessen?</p>
                                <p onClick={() => changeRegisterState(true)}>Noch kein Account? Jetzt erstellen...</p>
                            </form>
                        </>
                    )
                    }
            </div>
            <h3>🍪 Datenschutzhinweis</h3>
            <h4>Ihre eingegebenen Daten (Benutzername, E-Mail-Adresse und Passwort) werden ausschließlich zur Erstellung und
                Verwaltung Ihres Benutzerkontos gespeichert und verarbeitet. Die Daten werden nicht an Dritte weitergegeben.
                Passwörter werden verschlüsselt gespeichert. Auf Ihre Daten hat lediglich unser Entwicklungsteam sowie der Inhaber
                dieser Seite zugriff. Passwörter können von uns nicht im Klartext eingesehen werden.</h4>
        </div>
    )
}
